











































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Subscription, {StripeInvoice} from '../../../../../api/v2/models/subscription'
import { subscriptionState } from '../../../../stores/subscription'
import PremiumService from '../../../../../api/v2/models/pre_service'
import { userState } from '../../../../stores/user'
import { calcTaxIncluded } from '../../../../utils/price'

@Component({
  components: {
  },
})
export default class ChangePlanCompletion extends Vue {
  subscription: Subscription | null = null
  stripeLastInvoice: StripeInvoice | null = null
  targetPremiumService: PremiumService | null = null
  isLoading = true
  calcTaxIncluded = calcTaxIncluded

  created() {
    this.getSubscription()
    this.getTargetPremiumService()
    userState.getUser()
  }

  getSubscription() {
    subscriptionState.getSubscription(this.$route.params.subscriptionId as any).then((response) => {
      if (response) {
        this.subscription = response.subscription
        this.stripeLastInvoice = response.stripeInvoices[0]
      }
    })
  }

  getTargetPremiumService() {
    subscriptionState.getTargetPremiumService(this.$route.params.subscriptionId as any, this.$route.query.targetPremiumServiceId as any).then((response) => {
      if (response) {
        this.targetPremiumService = response
        this.isLoading = false
      }
    })
  }
  localNumber(number: number) {
    return new Intl.NumberFormat("ja-JP").format(number)
  }
}
